import beforeSaveProfileHook from '../../../../models/profile/hooks/before-save'
import beforeSaveWorkoutHook from '../../../../modules/workout/model/hooks/before-save'
import { beforeSavePlanHook, PLAN_CLASS_NAME } from '../../../plan'
import { PROFILE_CLASS_NAME } from '../../../../models/profile/constants'
import getClassNameReduxUtil from '../../utils/get-class-name'
import { WORKOUT_CLASS_NAME } from '../../../workout'
import { EXERCISE_LOG_SUMMARY_CLASS_NAME } from '../../../exercise-log-summary/model/constants'
import { beforeSaveExerciseLogSummaryHook } from '../../../exercise-log-summary/model/hooks'

const CLASS_NAME_TO_FUNCTION = {
  [EXERCISE_LOG_SUMMARY_CLASS_NAME]: beforeSaveExerciseLogSummaryHook,
  [PROFILE_CLASS_NAME]: beforeSaveProfileHook,
  [PLAN_CLASS_NAME]: beforeSavePlanHook,
  [WORKOUT_CLASS_NAME]: beforeSaveWorkoutHook
}

function beforeSaveReduxHook (data) {
  const className = getClassNameReduxUtil(data)
  const fn = CLASS_NAME_TO_FUNCTION[className]
  if (!fn) {
    return data
  }
  return fn(data)
}

export default beforeSaveReduxHook
